export const tableBodyStyle = {
	boxShadow: 'inset 0 0 0 1px #E1E1E3',
	borderRadius: '8px',
}

export const tableRowStyle = {
	borderBottom: '1px solid #E1E1E3',
	'&:last-child': {
		borderBottom: 'none',
	},
}
